<template>
<v-data-table :headers="headers" :items="filteredItems" :search="search">
    <template v-slot:items="{ item }">
        <td>{{ item.Name }}</td>
        <td>{{ item.Mandatory ? 'Yes' : 'No' }}</td>
        <td>{{ item.IsActive ? 'Active' : 'Inactive' }}</td>
        <td>
            <v-btn color="primary" block @click="$emit('edit', item)">
                <span>Edit</span>
            </v-btn>
        </td>
    </template>
</v-data-table>
</template>

<script>
export default {
    props: {
        filteredItems: {
            type: Array,
            required: true
        },
        search: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            headers: [
                {
                    text: "Name",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Mandatory",
                    value: "Mandatory",
                    sortable: true
                },
                {
                    text: "Active",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "AttributeID",
                    sortable: false
                }
            ]
        }
    }
}
</script>
